import { BasePage } from '@/components/ui/base-page'

export function FlyTrapPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add FlyTrapPage specific content here */}
    </BasePage>
  )
}